export default "__VITE_ASSET__CanjngS0__"